import { Navigate, Route } from "metabase/router";
import * as Urls from "metabase/urls";

const activityPage = () =>
  import(/* webpackChunkName: "usage-analytics" */ "./pages/ActivityPage").then(
    ({ ActivityPage }) => ({ Component: ActivityPage }),
  );

const queryLogPage = () =>
  import(/* webpackChunkName: "usage-analytics" */ "./pages/QueryLogPage").then(
    ({ QueryLogPage }) => ({ Component: QueryLogPage }),
  );

const peoplePage = () =>
  import(/* webpackChunkName: "usage-analytics" */ "./pages/PeoplePage").then(
    ({ PeoplePage }) => ({ Component: PeoplePage }),
  );

const personPage = () =>
  import(/* webpackChunkName: "usage-analytics" */ "./pages/PersonPage").then(
    ({ PersonPage }) => ({ Component: PersonPage }),
  );

const itemPage = () =>
  import(/* webpackChunkName: "usage-analytics" */ "./pages/ItemPage").then(
    ({ ItemPage }) => ({ Component: ItemPage }),
  );

const retentionPage = () =>
  import(
    /* webpackChunkName: "usage-analytics" */ "./pages/RetentionPage"
  ).then(({ RetentionPage }) => ({ Component: RetentionPage }));

/** The Usage analytics pages, under /monitor/usage-analytics. */
export const getUsageAnalyticsRoutes = () => (
  <>
    <Route
      index
      element={<Navigate to={Urls.monitorUsageActivity()} replace />}
    />
    <Route path="activity" lazy={activityPage} />
    <Route path="queries" lazy={queryLogPage} />
    <Route path="people" lazy={peoplePage} />
    <Route path="people/:userId" lazy={personPage} />
    <Route path="item/:model/:itemId" lazy={itemPage} />
    <Route path="retention" lazy={retentionPage} />
  </>
);
